<template>
  <div>
    <van-loading size="24px" text-color="#0094ff" color="#0094ff" vertical v-if="loading">登录中...</van-loading>
    <div class="buttonList" v-else>
      <button @click="handleLogin" class="back-button">重新登录</button>
      <button @click="handleCustomer" class="customer-button">联系技术客服</button>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { getCode } from "@/services/login";
export default {
  async created() {
    const appid = this.$route.query?.appid || null;
    const openid = this.$route.query?.openid || "";
    const phone = this.$route.query?.phone || "";
    const user_name = this.$route.query?.user_name || "";


    if (!appid) {
      setTimeout(() => {
        Toast.fail("参数错误");
        this.loading = false;
      }, 500);
      return;
    }

    // 调用getCode会跳转到微信授权，授权成功后会直接回调到userInfo页面
    let result = await getCode({
      appid,
      state: "", //这个参数有坑，虽然用来传其他参数，单只能携带1个参数，不能携带多个参数，所以这里传空字符串
      prop: `appid=${appid}&openid=${openid}&phone=${phone}&user_name=${user_name}`
    });
    console.log("getCode result", result);
  },
  data() {
    return {
      loading: true
    };
  },
  methods: {
    handleLogin() {
      location.reload();
    },
    handleCustomer() {
      this.$router.push("/customer");
    }
  }
};
</script>

<style scoped>
body {
  background: linear-gradient(135deg, #e3f6fd 0%, #34acf3 100%);
  min-height: 100vh;
}

.buttonList {
  position: fixed;
  bottom: 20%;
  width: 100%;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  animation: fadeInUp 1s cubic-bezier(0.68, -0.55, 0.27, 1.55);
}

.back-button,
.customer-button {
  letter-spacing: 2px;
  width: 80%;
  color: #fff;
  padding: 0 20px;
  border: none;
  font-size: 17px;
  margin: 0 auto;
  height: 50px;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(52, 172, 243, 0.15);
  transition: transform 0.2s, box-shadow 0.2s;
  cursor: pointer;
}

.back-button {
  background: linear-gradient(90deg, #34acf3 0%, #5fd0ff 100%);
  animation: pulse 1.2s infinite;
}
.back-button:active {
  background: #2386b7 !important;
  transform: scale(0.97);
}

.customer-button {
  background: linear-gradient(90deg, #34acf3 0%, #67d56b 100%);
}
.customer-button:active {
  background: #34acf3 !important;
  transform: scale(0.97);
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(40px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(52, 172, 243, 0.3);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(52, 172, 243, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(52, 172, 243, 0);
  }
}

.van-loading {
  margin-top: 120px;
  animation: loadingFade 1.2s infinite alternate;
}

@keyframes loadingFade {
  0% {
    opacity: 0.6;
  }
  100% {
    opacity: 1;
  }
}
</style>
